exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.settings-icon[data-v-25f055ce] {\n  font-size: 1.4rem;\n}\n.enabled[data-v-25f055ce] {\n  color: #2196f3;\n}\n.disabled[data-v-25f055ce] {\n  color: #e3342f;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25f055ce","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Patient/OfficeSettings.vue
// module id = 585
// module chunks = 1